let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aXxt3")).then(() => parcelRequire('i9AWo'));